/**
 * The app bar is 64 px (design §14.3) at every width and in both densities (TMMAPP-0099, visual
 * contract §2: compact density never shrinks the bar). Applied to the bar's toolbar and to every
 * spacer `Toolbar` that offsets content beneath the fixed bar, so they always agree.
 */
export const BAR_HEIGHT = 64;

export function useBarMinHeight(): number {
  return BAR_HEIGHT;
}

/**
 * The shell's full height (TMMAPP-0155 item 3): `100vh`, then `100dvh` where the browser has it, so
 * mobile Safari's collapsing toolbar never leaves a gap under a full-height page. (An `sx` array
 * would be breakpoints, not a fallback, hence the `@supports`.)
 */
export const FULL_HEIGHT_SX = {
  minHeight: '100vh',
  '@supports (min-height: 100dvh)': { minHeight: '100dvh' },
} as const;
